/**
 * components/index.js
 *
 * All components are listed here.
 */

export {default as EpicGamesNavWrapper} from './nav/EpicGamesNavWrapper';
export {default as EpicGamesFooterWrapper} from './footer/EpicGamesFooterWrapper';
export {default as Message} from './message/Message';
export {default as Video} from './common/Video';
export {default as Gallery} from './common/Gallery';

//export {default as Error500} from './error/Error500';
